export const WhatsAppRoutes = [
  {
    path: 'whatsapp/messageTemplates',
    children: [
      {
        path: 'create',
        alias: 'waTemplateCreate',
        lazy: () => import('../components/WaTemplatePage/WaTemplatePage'),
      },
      {
        path: 'view/:template_name',
        alias: 'waTemplateItem',
        query: ['language_code'],
        lazy: () => import('../components/WaTemplatePage/WaTemplatePage'),
      },
    ],
  },
] as const
